import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import useIpZipCode from '../../hooks/useIpZipCode';

interface ZipCodeContextType {
  zipCode: string;
  setZipCode: (zip: string) => void;
  isFetching: boolean;
}

const ZipCodeContext = createContext<ZipCodeContextType | undefined>(undefined);

export const ZipCodeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { ipZipCode, isFetching } = useIpZipCode();
  const [zipCode, setZipCode] = useState('');

  useEffect(() => {
    if (ipZipCode) {
      setZipCode(ipZipCode);
    }
  }, [ipZipCode]);

  return (
    <ZipCodeContext.Provider value={{ zipCode, setZipCode, isFetching }}>
      {children}
    </ZipCodeContext.Provider>
  );
};

export const useZipCode = () => {
  const context = useContext(ZipCodeContext);
  if (context === undefined) {
    throw new Error('useZipCode must be used within a ZipCodeProvider');
  }
  return context;
};
